export const canVoidPrepayments = prepayments =>
  prepayments.length > 0 &&
  prepayments.every(item => item.status?.id === "awaiting_authorisation");

export const canAuthorisePrepayments = prepayments =>
  prepayments.length > 0 &&
  prepayments.every(item => item.status?.id === "awaiting_authorisation");

export const canMarkPrepaymentsPaid = prepayments =>
  prepayments.length > 0 && prepayments.every(item => item.status?.id === "authorised");
